<template>
  <div>
    <div class="albumContainer">
      <div class="infocontainer">
        <div class="info">
          <h1>{{ current_item.title }}</h1>
          <p>{{ current_item.desc }}</p>
        </div>
      </div>
      <div class="gallery">
        <template v-for="(i, index) of current_item.database">
          <figure :key="index">
            <v-lazy-image :src="i.image" :src-placeholder="i.lqthumbnail" :alt="i.name" />
          </figure>
        </template>
        <AlbumNav class="albumNavInsta" />
      </div>
    </div>
    <MyFooter :footer-image="footerImage" />
  </div>
</template>

<script>
import AlbumNav from "@/components/AlbumNav";
import MyFooter from "@/components/MyFooter";
import VLazyImage from "v-lazy-image";
import { mapGetters } from "vuex";
export default {
  name: "Album",
  props: ["url_title"],
  components: {
    MyFooter,
    VLazyImage,
    AlbumNav
  },
  data() {
    return {
      /* zero: null, */
      footerImage: require("../assets/star.svg")
    };
  },
  computed: {
    ...mapGetters(["current_item"])
  },
  beforeMount: function() {
    /* this.zero = this.current_item.database[0]; */
  },
  created: function() {
    this.$store.dispatch("set_current_item", this.url_title);
  },
  beforeRouteUpdate: function(to, from, next) {
    this.$store.dispatch("zbar_duck", true);
    next();
  }
};
</script>

<style scoped lang="scss">
.albumContainer {
  @include mediumScreen {
    width: 85vw;
    margin: auto;
  }
  @include bigScreen {
    display: grid;
    grid-template-columns: 2fr 5fr;
  }
  .infocontainer {
    width: 100%;
    height: 100%;
    .info {
      text-align: center;
      margin: 1rem;

      @include bigScreen {
        display: flex;
        margin: 2rem;
        flex-direction: column;
        /* align-items: center; */
        justify-content: center;
        text-align: right;
        position: sticky;
        top: 0;
        height: 40vh;
      }
      h1 {
        color: $accentPrimary;
        font-size: 2rem;
      }
      p {
        font-size: 1.3rem;
      }
    }
  }

  .gallery {
    width: 100%;
    figure {
      margin: 1rem;
      img {
        background: $lightSecondary;
      }
      @include mediumScreen {
        margin: 1rem 0;
      }

      @include bigScreen {
        margin: 2rem 0;
      }
    }
  }

  .albumNavInsta {
    margin: 1rem;
    text-align: center;
  }
}
</style>
